import { RecentCheckedItemJsEnv } from '../../../models/recent_checked_item/recent_checked_item_js_env';
import { RecentCheckedItem as RecentCheckedItemObj } from '../../../models/recent_checked_item/recent_checked_item_js_env';
import { html } from 'lit-html';
import { each } from '../../../../core/component';
import { RecentCheckedItemAction } from '../../../../core/actions/recent_checked_item/recent_checked_item_action';
import { getNoPhotoImageUrl, getAssetsUrlBase } from '../../../models/common/static_resource_util'

export const RecentCheckedItems = (recentCheckedItemJsEnv: RecentCheckedItemJsEnv) => {
  return html`
    <div class="o-footer_recentCheckItemsPc">
      <div class="o-carousel js-lazy-img js-carousel -recently" id="recent_checked_item_carousel">
        <div class="swiper-container js-carousel-body" data-type="recently" data-perview="10" data-space="24">
          <div class="swiper-wrapper">
            ${recentCheckedItemJsEnv.hasRecentCheckedItems ? each(recentCheckedItemJsEnv.recentCheckedItems, RecentCheckedItem) : '最近チェックした商品はありません。'}
          </div>
        </div>
        <div class="o-carousel_pagination js-carousel_pagination">ページ：<span
          class="o-carousel_count js-carousel_count"></span><a href="#"
                                                               class="a-textlink o-carousel_toFirst js-carousel_toFirst">最初に戻る</a>
        </div>
        <button class="a-ctrlbtn js-lazy-img -prev o-carousel_prev js-carousel_prev" type="button"><span class="a-ctrlbtn_text">前のスライドへ</span>
        </button>
        <button class="a-ctrlbtn js-lazy-img -next o-carousel_next js-carousel_next" type="button"><span class="a-ctrlbtn_text">次のスライドへ</span>
        </button>
      </div>
    </div>
  `;
};

const RecentCheckedItem = (recentCheckedItem: RecentCheckedItemObj) => html`
  <div class="o-carousel_slide swiper-slide js-carousel_slide">
    <div class="o-carousel_slideinner">
      <div class="m-simpleitemcard -vertical"><a href="/p/${buildItemUrl(recentCheckedItem)}/" class="m-simpleitemcard_link">
        <div class="m-simpleitemcard_tag"></div>
        <div class="m-simpleitemcard_img">
          <div class="a-img -radius"><span class="a-img_imgWrap"><img
            data-src="${recentCheckedItem.imageUrl ? recentCheckedItem.imageUrl: getNoPhotoImageUrl()}"
            class="a-img_img js-lazy-img" alt="${recentCheckedItem.itemName}" width="140" height="140"/></span></div>
        </div>
      </a></div>
      <button
        @click="${() => RecentCheckedItemAction.delete(recentCheckedItem.supplierId, recentCheckedItem.catalogItemCode)}"
        class="o-carousel_deleteBtn js-carousel_deleteBtn" type="button"><span
        class="a-icon -size8"><img class="a-icon_img" src="${getAssetsUrlBase() + "images/icon_close.svg"}"
                                   alt="削除" width="8" height="8"/></span></button>
    </div>
  </div>
`;

const buildItemUrl = (recentCheckedItem: RecentCheckedItemObj) => {
  if (recentCheckedItem.supplierId === "P00001") {
    return recentCheckedItem.catalogItemCode;
  } else {
    return recentCheckedItem.supplierId + "-" + recentCheckedItem.catalogItemCode
  }
}
